<template>
    <div class="atelier-simulator-container">
        <div class="global-limited-1360px-container">
            <CommonComponentsProductsAtelierSimulatorSwipper />
            <CommonComponentsProductsAtelierSimulatorTool />
            <CommonComponentsProductsAtelierSimulatorPlugin />
        </div>
    </div>
</template>

<style lang="less" scoped>
    .atelier-simulator-container {
        background-color: #000000;
        width: 100%;
        font-family: Montserrat, 'HarmonyOS Sans SC';
        color: #fff;
    }
</style>
